import { Controller } from "@hotwired/stimulus"

// Says what share of the day the calorie target currently is.
//
// The hint used to read "A third of your daily 1,910" — true of the value
// the field opens with, and wrong the moment somebody steps it. A sentence
// that describes a number has to move with it.
//
// The wording matches RecipeGenerationsHelper::SHARE_WORDS, which renders
// the first paint. Two copies of a phrase list is a drift waiting to
// happen, so the bands are the same numbers in the same order and any
// change belongs in both.
export default class extends Controller {
  static targets = ["hint"]
  static values = { daily: Number }

  static WORDS = [
    [0.15, "A light meal"],
    [0.22, "About a fifth of your day"],
    [0.28, "About a quarter of your day"],
    [0.38, "About a third of your day"],
    [0.45, "Getting on for half your day"],
    [0.58, "About half your day"],
    [0.72, "Around two thirds of your day"],
    [0.88, "Most of your day"],
    [1.05, "Just about your whole day"],
    [Infinity, "More than your whole day"]
  ]

  refresh() {
    if (!this.hasHintTarget || !this.dailyValue) return

    // The stepper keeps the real value in a hidden field; the visible
    // figure is rendered text and can carry a fraction glyph.
    const field = this.element.querySelector("input[type=hidden]")
    const kcal = Number(field?.value)
    if (!Number.isFinite(kcal) || kcal <= 0) return

    const share = kcal / this.dailyValue
    const [, words] = this.constructor.WORDS.find(([ceiling]) => share < ceiling)
    this.hintTarget.textContent = words
  }
}
